import { stringifyFptiProps } from '@/utils'

export const BUSINESS_PROFILE_PAGE_SHOWN_TO_BUYER = {
  eventName: 'business_profile_buyer_view_shown',
}

export const BUSINESS_PROFILE_PAGE_SHOWN_TO_SELLER = {
  eventName: 'business_profile_seller_view_shown',
}

export const BUSINESS_PROFILE_BUYER_VIEW_SHARE_CLICK_FPTI = stringifyFptiProps({
  eventName: 'business_profile_buyer_view_share_click',
})

export * from '../../fpti'
